import React from "react";
import { useIntl } from "react-intl";
import { Tooltip, Typography } from "antd";

import StateIcon from "../../app/generic/stateIcon";

const { Text } = Typography;

const DimensionRow = ({ value, warning, errors }) => {
  const intl = useIntl();
  return (
    <>
      {warning ? (
        value
      ) : (
        <Tooltip
          title={intl.formatMessage({
            id: "consignment.colli.invalidValue",
            defaultMessage: "špatná hodnota",
          })}
        >
          <Text type="danger">{value}</Text>
        </Tooltip>
      )}
      {errors?.length > 0 && (
        <StateIcon valid={false} messages={errors} className="margin-left-8" />
      )}
    </>
  );
};

export default DimensionRow;
